const PaginationThemes = {
  products: {
    limitOptions: [5, 10, 20, 30, 40, 50],
    label: "results",
  },
  tracking: {
    limitOptions: [5, 10, 20],
    label: "orders",
  },
};

export default PaginationThemes;
